/**
 * @file Component representing the footer of the application.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { LocalisationService } from '../../core/localisation.service';
import { TranslateService } from '@ngx-translate/core';
import { OverlayService } from '../../core/overlay.service';
import { UserService } from '../../user.service';
import { ConfigurationsService } from '../../configurations.service';
import { RoutesService } from '../../routes.service';
import { SettingsService } from '../../settings.service';
import { ErrorService } from '../../core/error.service';
import { Router } from '@angular/router';
import { AlertsService } from '../../core/alerts.service';
/**
 * Component representing the footer of the application.
 */
var FooterComponent = /** @class */ (function () {
    /**
     * Constructs the footer of the application.
     * @param localisationService  The localization service to support multi language.
     * @param translateService The translate service to support multi language.
     */
    function FooterComponent(localisationService, overlayService, translateService, userService, configurationsService, routesService, settingsService, errorService, router, alertsService) {
        this.localisationService = localisationService;
        this.overlayService = overlayService;
        this.translateService = translateService;
        this.userService = userService;
        this.configurationsService = configurationsService;
        this.routesService = routesService;
        this.settingsService = settingsService;
        this.errorService = errorService;
        this.router = router;
        this.alertsService = alertsService;
    }
    FooterComponent.prototype.onKeydownHandler = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.changeRole()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FooterComponent.prototype.onVersionClick = function () {
        this.overlayService.createOverlay({
            action: {
                configuration: {
                    components: [
                        {
                            component: 'VersionInfoComponent',
                            configuration: { key: 'header/actions/account' }
                        }
                    ],
                    instruction: '',
                    labelKey: ''
                },
                labelKey: ''
            }
        });
    };
    Object.defineProperty(FooterComponent.prototype, "languages", {
        /** Gets the supported languages. */
        get: function () {
            return this.localisationService.languages;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "currentLanguage", {
        /** Gets the current language of the application. */
        get: function () {
            return this.translateService.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    FooterComponent.prototype.onLanguageChange = function (locale) {
        this.localisationService.setLanguage(locale);
    };
    Object.defineProperty(FooterComponent.prototype, "roles", {
        /** Gets the supported roles. */
        get: function () {
            return this.settingsService.settings.frontend.roles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FooterComponent.prototype, "currentRole", {
        /** Gets the current language of the application. */
        get: function () {
            return this.userService.html5role;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Has the current user a Symagic rol (deep role, not the one used for configuration etc.)
     * https://github.com/Symagic/html5/issues/3545#issuecomment-574148367
     * */
    FooterComponent.prototype.isSymagicRole = function () {
        return (this.userService.user.HTML5Role.toLowerCase() === 'symagic');
    };
    FooterComponent.prototype.changeRole = function (role) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.userService.user.HTML5Role.toLowerCase() !== 'symagic') {
                            this.alertsService.createAlert('warning', 'Change of role is not allowed');
                            return [2 /*return*/];
                        }
                        while (!this.settingsService.settings.frontend.roles.includes(role)) {
                            role = window.prompt('What is your preferred role?', this.userService.html5role);
                        }
                        if (!(role !== this.userService.html5role)) return [3 /*break*/, 3];
                        this.userService.changeRole(role);
                        return [4 /*yield*/, this.configurationsService.bootInit()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.routesService.bootInit()];
                    case 2:
                        _a.sent();
                        this.router.resetConfig(this.routesService.routes);
                        this.router.navigateByUrl('/');
                        this.alertsService.createAlert('success', 'Your role is changed');
                        return [3 /*break*/, 4];
                    case 3:
                        this.alertsService.createAlert('warning', 'No change of role needed');
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return FooterComponent;
}());
export { FooterComponent };
